


import { Component, Vue, Watch } from "vue-property-decorator";

import { AdsPublications } from "App";

import { EventBus, $t } from "App/IOC";

import { CustomNotification } from "App/Models";

import FtpForm from "../Form.vue";
import ApiForm from "../ApiForm.vue";
import SetupGatewayPanel from "./SetupGatewayPanel.vue";

import Record from "Web/Components/Record.vue";

@Component({
    components: {
        FtpForm,
        ApiForm,
        SetupGatewayPanel,
        Record
    }
})
export default class SingleAdsPublicationView extends Vue {
    private record: any = null;
    private loading: boolean = true;

    private async created(): Promise<void> {
        await this.setup();
    }

    /* Reload when navigating straight to a sibling portal via the prev/next arrows. */
    @Watch( "$route" )
    private onRouteChange( to: any, from: any ): void {
        if( to.name !== "ads-publication" || from.params.id === to.params.id )
            return;

        this.record = null;
        this.loading = true;
        this.setup();
    }

    private async setup(): Promise<void> {
        const id = Number( this.$route.params.id );

        /* Generic Get hits /gateway-ftp/{id}, which carries gateway_type for every portal but
           returns empty fields for API gateways. Read the type first, then re-fetch API portals
           through /gateway-api/{id} so the API form gets its real name/host/credentials. */
        const [ record, error ] = await AdsPublications.Get( id );

        if( error !== undefined || record === undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        if( this.isApiType( record ) ) {
            const [ apiRecord, apiError ] = await AdsPublications.GetApi( id );
            if( apiError === undefined && apiRecord !== undefined ) {
                this.record = apiRecord;
                this.loading = false;

                const apiName = this.headline;
                if( apiName !== "" )
                    document.title = apiName;
                return;
            }
        }

        this.record = record;
        this.loading = false;

        const name = this.headline;
        if( name !== "" )
            document.title = name;
    }

    /* API-type gateways (gateway_type id 2) — Amanda and the other API portals. */
    private isApiType( record: any ): boolean {
        const type = record && ( record.gateway_type || record.Gateway_type );
        return type !== undefined && type !== null
            && ( type.id === 2 || type.name === "API" );
    }

    private get isApi(): boolean {
        return this.isApiType( this.record );
    }

    private get headline(): string {
        if( this.record === null )
            return "";

        return this.record.name || this.record.Name || "";
    }

    /* Form save succeeded: confirm and return to the list, which reloads with fresh data. */
    private onSaved(): void {
        EventBus.Publish(
            "Notification",
            CustomNotification.Success(
                $t( "ADS_PUBLICATION_createSuccessTitle" ),
                $t( "ADS_PUBLICATION_createUpdateMessage" )
            )
        );

        this.$router.push( "/ads-publications" );
    }
}
